import '../pages.css';
import { Link } from 'react-router-dom';

const PFM = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>PFM (Porcelain-Fused-to-Metal)</h1>
                    <p className="product-tagline">Strength meets lifelike esthetics</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            PFM restorations from <strong>AbELab</strong> combine the strength of metal frameworks with lifelike porcelain
                            esthetics. These restorations provide long-term durability, excellent marginal integrity, and proven periodontal
                            compatibility, enhanced by CAD/CAM precision.
                        </p>
                    </div>

                    <div className="product-two-column">
                        <div className="product-section">
                            <h2>Indications</h2>
                            <ul>
                                <li>Crowns</li>
                                <li>Bridges (up to 14 units)</li>
                                <li>Implant-supported restorations</li>
                                <li>Partial denture frameworks</li>
                            </ul>
                        </div>

                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>Metal allergies</li>
                                <li>Extremely large pulp chambers</li>
                                <li>Very short clinical crowns with insufficient retention</li>
                            </ul>
                        </div>
                    </div>

                    <div className="product-section">
                        <h2>Preparation</h2>
                        <ul>
                            <li>Chamfer margin is ideal</li>
                            <li>Shoulder margin required for porcelain labial margins</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Cementation</h2>
                        <ul>
                            <li>Panavia™ 21 (tin plated)</li>
                            <li>Glass ionomer cement</li>
                            <li>Zinc phosphate or polycarboxylate cement</li>
                            <li>Resin ionomer cement</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Technical Notes</h2>
                        <p>Adjust porcelain with fine diamonds under water cooling.</p>
                        <p>Polish using rubber wheels and diamond paste.</p>
                    </div>

                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2750 / D6750</strong> – PFM, high noble</li>
                            <li><strong>D2751 / D6751</strong> – PFM, non-precious</li>
                            <li><strong>D2752 / D6752</strong> – PFM, semi-precious</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PFM;
